<app-module-loader moduleId="update-tab" selector="app-update" [load]="loadTab"
  [inputs]="{
    fundraiser: fundraiser,
    updates: updates,
    viewMore: updates?.next_page_url?true:false,
    isFundraiserEnded: isFundraiserEnded,
    pageName: 'story',
    updateCounts: getLength(updates),
    sharedCounts: sharedCounts,
    isDonated: isDonated
  }" [outputs]="{viewMoreUpdates: viewUpdateEvent}">
</app-module-loader>